import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import InstagramIcon from '../components/svg/InstagramIcon.vue'
import LinkedInIcon from '../components/svg/LinkedInIcon.vue'
import WebsiteIcon from '../components/svg/WebsiteIcon.vue'
import EmailIcon from '../components/svg/EmailIcon'
import ErrorIcon from '../components/svg/ErrorIcon'
import ChatIcon from '../components/svg/ChatIcon';
import OsiguLogo from '../components/svg/OsiguLogo';
import EmptyStateIcon from '../components/svg/EmptyStateIcon'
import KoneksiPoweredByOsigu from '../components/svg/KoneksiPoweredByOsigu'
import GnpLogo from '../components/svg/GnpLogo.vue'
import HexaludLogo from '../components/svg/HexaludLogo.vue'
import KoneksiEmailIcon from '../components/svg/KoneksiEmailIcon'
import BiometricValidationIcon from '../components/svg/BiometricValidationIcon'
import { config } from './env.config'
import DiagnosesIcon from '@/components/svg/DiagnosesIcon';
import EmailNotificationIcon from '../components/svg/EmailNotificationIcon.vue'

let vuetify

if(config.theme){
  
  if(config.theme === 'OSIGU') {
    vuetify = new Vuetify({
      theme: {
        options: {
          customProperties: true
        },
        themes: {
          light: {
            primary: '#528ef7',
            secondary: '#1f3261',
            error: '#FF726D',
            accent: '#FF726D',
            'osg-gray': '#828282',
            'osg-black': '#2a2a2a',
            'osg-active': '#e7effe',
            'osg-active-border': '#e7effe',
            'osg-active-font': '#528ef7',
            'osg-active-icon' : '#1f3261',
            'osg-active-text': '#1f3261',
            'osg-gray-text': '#4f4f4f',
          }
        }
      },
      icons: {
        values: {
          'osg-instagram': {
            component: InstagramIcon
          },
          'osg-linkedin': {
            component: LinkedInIcon
          },
          'osg-website': {
            component: WebsiteIcon
          },
          'osg-error': {
            component: ErrorIcon
          },
          'osg-email': {
            component: EmailIcon
          },
          'osg-chat': {
            component: ChatIcon
          },
          'osg-logo': {
            component: OsiguLogo
          },
          'osg-empty-state': {
            component: EmptyStateIcon
          },
          'osg-biometric-validation': {
            component: BiometricValidationIcon
          },
          'osg-diagnoses-icon': {
            component: DiagnosesIcon
          },
          'osg-emailnotification':{
            component: EmailNotificationIcon
          },
        }
      }
    })
  }

  if(config.theme === 'HEXALUD') {
    vuetify = new Vuetify({
      theme: {
        options: {
          customProperties: true
        },
        themes: {
          light: {
            primary: '#010F33',
            secondary: '#001A5B',
            error: '#FF726D',
            accent: '#FF726D',
            'osg-gray': '#828282',
            'osg-black': '#2a2a2a',
            'osg-active': '#e7effe',
            'osg-active-border': '#e7effe',
            'osg-active-font': '#528ef7',
            'osg-active-icon' : '#1f3261',
            'osg-active-text': '#1f3261',
            'osg-gray-text': '#4f4f4f',
          }
        }
      },
      icons: {
        values: {
          'osg-instagram': {
            component: InstagramIcon
          },
          'osg-linkedin': {
            component: LinkedInIcon
          },
          'osg-website': {
            component: WebsiteIcon
          },
          'osg-error': {
            component: ErrorIcon
          },
          'osg-email': {
            component: EmailIcon
          },
          'osg-chat': {
            component: ChatIcon
          },
          'osg-logo': {
            component: HexaludLogo
          },
          'osg-empty-state': {
            component: EmptyStateIcon
          },
          'osg-biometric-validation': {
            component: BiometricValidationIcon
          },
          'osg-diagnoses-icon': {
            component: DiagnosesIcon
          },
          'osg-emailnotification':{
            component: EmailNotificationIcon
          },
        }
      }
    })
  }

  if(config.theme === 'KONEKSI'){
    vuetify = new Vuetify({
      theme: {
        options: {
          customProperties: true
        },
        themes: {
          light: {
            primary: '#662f91',
            secondary: '#4F4F4F',
            error: '#FF726D',
            accent: '#FF726D',
            'osg-gray': '#828282',
            'osg-black': '#000000',
            'osg-active': '#ffffff',
            'osg-active-border': '#662f91',
            'osg-active-font': '#662f91',
            'osg-active-icon' : '#662F91',
            'osg-active-text': '#1f3261',
            'osg-gray-text': '#4f4f4f',
          }
        }
      },
      icons: {
        values: {
          'osg-instagram': {
            component: InstagramIcon
          },
          'osg-linkedin': {
            component: LinkedInIcon
          },
          'osg-website': {
            component: WebsiteIcon
          },
          'osg-error': {
            component: ErrorIcon
          },
          'osg-email': {
            component: KoneksiEmailIcon
          },
          'osg-chat': {
            component: ChatIcon
          },
          'osg-logo': {
            component: KoneksiPoweredByOsigu
          },
          'osg-empty-state': {
            component: EmptyStateIcon
          }
        }
      }
    })
  }

  if(config.theme === 'GNP'){
    vuetify = new Vuetify({
      theme: {
        options: {
          customProperties: true
        },
        themes: {
          light: {
            primary: '#FC6C25',
            secondary: '#1F3261',
            error: '#FF726D',
            accent: '#FF726D',
            'osg-gray': '#828282',
            'osg-black': '#2a2a2a',
            'osg-active': '#ffffff',
            'osg-active-border': '#662f91',
            'osg-active-font': '#662f91',
            'osg-active-icon' : '#662F91',
            'osg-active-text': '#1f3261',
            'osg-gray-text': '#4f4f4f',
          }
        }
      },
      icons: {
        values: {
          'osg-instagram': {
            component: InstagramIcon
          },
          'osg-linkedin': {
            component: LinkedInIcon
          },
          'osg-website': {
            component: WebsiteIcon
          },
          'osg-error': {
            component: ErrorIcon
          },
          'osg-email': {
            component: KoneksiEmailIcon
          },
          'osg-chat': {
            component: ChatIcon
          },
          'osg-logo': {
            component: GnpLogo
          },
          'osg-empty-state': {
            component: EmptyStateIcon
          },
          'osg-diagnoses-icon': {
            component: DiagnosesIcon
          },
          'osg-emailnotification':{
            component: EmailNotificationIcon
          },
        }
      }
    })
  }
}


Vue.use(Vuetify)

export default new Vuetify({...vuetify})
